import { useCommonAppTranslation } from '@libs/utils/translations'
import RestTypes from '@spa/constants/RestTypes'
import CardInfo from '@spa/scenes/Plannings/components/Card/CardInfo/CardInfo'
import type { RestModel } from '@spa/scenes/Plannings/redux/models/Rest'
import React from 'react'
import type { FC } from 'react'

type Props = {
  rest: RestModel
}
const RestDetails: FC<Props> = ({ rest }) => {
  const { t } = useCommonAppTranslation()
  if (!rest) {
    return null
  }
  const rest_type = rest.rest_type ? rest.rest_type : 'default_rest'
  const type = RestTypes.get(rest_type)

  return (
    <CardInfo.Content>
      <div data-testid='rest-details'>{t(type?.name)}</div>
    </CardInfo.Content>
  )
}

export default RestDetails
